// decoratorsBeforeExport: true
import Vue from 'vue';

import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import CompositionExport from './modules/CompositionExportModule';

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
    key: 'fmm-composition-manager',
    storage: localStorage,
});

export default new Vuex.Store({
    state: {},
    modules: {
        CompositionExport,
    },
    plugins: [
        vuexPersist.plugin,
    ],
});
